import React, { memo } from 'react';

import { useSelector } from 'react-redux';

import _isEqual from 'lodash/isEqual';

import { FilteredResultsText } from 'reaxl-filters';

import {
    srpFiltersDuck,
    srpPaginationDuck,
    srpResultsDuck,
    srpSupplementalDuck,
} from '@/ducks/srp';

function SearchResultsPageNumContainer() {
    const maxResultCount = useSelector(srpResultsDuck.selectors.getMaxActiveResultsCount);

    const pagination = useSelector(srpPaginationDuck.selectors.getDuckState);
    const supplementalListings = useSelector(srpSupplementalDuck.selectors.getActiveInventory);

    const numRecordsData = { value: pagination.numRecords };
    const resultCount = useSelector(srpResultsDuck.selectors.getResultsCount);

    const isLastPage = pagination.currentPage >= Math.ceil(resultCount / pagination.numRecords);
    const searchRadius = useSelector(srpFiltersDuck.selectors.getSelectedSearchRadius);
    const showSupplementalResults = isLastPage && !!searchRadius;
    const { currentPage } = pagination;

    return (
        <FilteredResultsText
            className="text-size-300"
            resultCount={resultCount}
            pageCount={currentPage}
            maxResultCount={maxResultCount}
            numRecordsData={numRecordsData}
            supplementalListings={supplementalListings}
            showSupplementalResults={showSupplementalResults}
        />
    );
}

export default memo(SearchResultsPageNumContainer, _isEqual);
